module.exports = __webpack_public_path__ + "img/arrow-select.6d805e22.svg";